export default __webpack_public_path__ + "static/media/WIB_ARABIC.85501e8f.jpg";